module.exports = __webpack_public_path__ + "static/media/Resume_icon.d2f5100d.svg";